(function () {
  function initCategoryForms() {
    if (!window.theme || !theme.AjaxProduct || !theme.settings) return;
    if (theme.settings.cartType !== 'drawer' && theme.settings.cartType !== 'sticky') return;
    document.querySelectorAll('[data-gibbon-category-form]').forEach(function (form) {
      new theme.AjaxProduct(form, '.gibbon-category-add');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCategoryForms);
  else initCategoryForms();
  document.addEventListener('shopify:section:load', initCategoryForms);
  document.addEventListener('collection:reloaded', initCategoryForms);
})();
